var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:(_vm.isActive? 'active' : ''),on:{"click":function($event){return _vm.$emit('clicked', $event,  _vm.emitValue )}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }